import { TypedDocumentNode, gql } from '@apollo/client';
import { ReactNode } from 'react';

import useEvents from '@sorare/core/src/lib/events/useEvents';
import { ClickMarketTrendsLink_TileType } from '@sorare/core/src/protos/events/platform/web/events';

import { ClickMarketTrendsEventProperties } from 'components/market/Trending/types';

import { PlayerRecommendation } from '../PlayerRecommendation';
import { Row } from '../Row';
import { PlayerRecommendationRow_anyPlayer } from './__generated__/index.graphql';

type Props = {
  players: PlayerRecommendationRow_anyPlayer[];
  loading: boolean;
  title: ReactNode;
  extra?: ReactNode;
  background?: string;
  chip?: ReactNode;
  onStatsClick: (slug: string) => void;
  eventProperties: ClickMarketTrendsEventProperties;
};

export const PlayerRecommendationRow = ({
  players,
  loading,
  title,
  extra,
  background,
  chip,
  onStatsClick,
  eventProperties,
}: Props) => {
  const track = useEvents();

  return (
    <Row
      loading={loading}
      title={title}
      background={background}
      extra={extra}
      items={players.map(p => {
        const trackForYouClick = () =>
          track('Click Market Trends Link', {
            tileType: ClickMarketTrendsLink_TileType.PLAYER,
            playerSlug: p.slug,
            ...eventProperties,
          });
        return (
          <PlayerRecommendation
            chip={chip}
            key={p.slug}
            player={p}
            onStatsClick={() => onStatsClick(p.slug)}
            trackForYouClick={trackForYouClick}
          />
        );
      })}
    />
  );
};

PlayerRecommendationRow.fragments = {
  anyPlayer: gql`
    fragment PlayerRecommendationRow_anyPlayer on AnyPlayerInterface {
      slug
      ...PlayerRecommendation_anyPlayer
    }
    ${PlayerRecommendation.fragments.anyPlayer}
  ` as TypedDocumentNode<PlayerRecommendationRow_anyPlayer>,
};
